import { CCol } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'

const PreviewImage = ({ file, width, height, className }) => {
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    if (!file) {
      setPreview(null)
      return
    }

    // ✅ CASE 1: File object (your current logic)
    if (file instanceof File) {
      const reader = new FileReader()
      reader.onload = () => setPreview(reader.result)
      reader.readAsDataURL(file)
    }

    // ✅ CASE 2: String (existing image from backend)
    else if (typeof file === 'string') {
      const baseUrl = process.env.REACT_APP_API_URL
      setPreview(baseUrl + 'uploads/gameprize/' + file)
    }

    return () => {
      setPreview(null)
    }
  }, [file])

  if (!preview) return null

  return (
    <CCol className={className}>
      <img
        src={preview}
        alt="Preview"
        width={width}
        height={height}
        style={{ objectFit: 'cover', borderRadius: '6px' }}
      />
    </CCol>
  )
}

export default PreviewImage
